import React from "react";
import { Card, Col, Collapse, Form, Input, Row, Select } from "antd";
import i18n from "translations/i18n";
import {
  DESCRIPTION_TEXT_MAX_CHAR,
  DESCRIPTION_TEXT_ROWS,
  SHORT_DESCRIPTION_TEXT_MAX_CHAR,
  SHORT_DESCRIPTION_TEXT_ROWS,
} from "../../../../constants/InputConstant";
import { InfoCircleOutlined } from "@ant-design/icons";
import { PRODUCT_MAIN_LANGUAGE, PRODUCT_TRANSLATIONS_LANGUAGES } from "../../../../constants/ProductConstant";

const { Option } = Select;

const TranslationField = (props) => {
  const isBundle = Form.useWatch("isBundle", props.form);

  return (
    <Row gutter={16}>
      <Col xs={24} sm={24}>
        <Collapse>
          {PRODUCT_TRANSLATIONS_LANGUAGES.filter((lang) => lang.code !== PRODUCT_MAIN_LANGUAGE).map((lang) => {
            const attributes =
              lang.code === "nl"
                ? props.attributesNL
                : lang.code === "de"
                  ? props.attributesDE
                  : lang.code === "fr"
                    ? props.attributesFR
                    : null;
            return (
              <Collapse.Panel key={lang.code} header={i18n.t(lang.label)} forceRender>
                <Card title={i18n.t("product_info")}>
                  <Form.Item name={`name_${lang.code}`} label={i18n.t("product_name")}>
                    <Input placeholder={i18n.t("name")} disabled={props.isFieldDisabled} />
                  </Form.Item>
                  <Form.Item name={`shortDescription_${lang.code}`} label={i18n.t("description_short")}>
                    <Input.TextArea
                      rows={SHORT_DESCRIPTION_TEXT_ROWS}
                      showCount
                      maxLength={SHORT_DESCRIPTION_TEXT_MAX_CHAR}
                      placeholder={i18n.t("form.enter_description_short")}
                      disabled={props.isFieldDisabled}
                    />
                  </Form.Item>
                  <Form.Item
                    name={`description_${lang.code}`}
                    label={i18n.t("description")}
                    tooltip={{ title: i18n.t("form.description_tooltip"), icon: <InfoCircleOutlined /> }}
                  >
                    <Input.TextArea
                      rows={DESCRIPTION_TEXT_ROWS}
                      showCount
                      maxLength={DESCRIPTION_TEXT_MAX_CHAR}
                      placeholder={i18n.t("form.enter_description")}
                      disabled={props.isFieldDisabled}
                    />
                  </Form.Item>

                  {/* Category - alleen tonen als NIET bundle */}
                  {!isBundle && (
                    <Form.Item name={`category_${lang.code}`} label={i18n.t("category")}>
                      <Select
                        style={{ width: "100%" }}
                        placeholder={i18n.t("form.enter_category")}
                        notFoundContent={<span>{i18n.t("table_no_categories")}</span>}
                        disabled={props.isFieldDisabled}
                      >
                        {props.categories.map((category) => (
                          <Option key={category}>{category}</Option>
                        ))}
                      </Select>
                    </Form.Item>
                  )}

                  {/* Attributes - alleen tonen als NIET bundle */}
                  {!isBundle && (
                    <Form.Item name={`attributes_${lang.code}`} label={i18n.t("attributes")}>
                      <Select
                        mode="tags"
                        style={{ width: "100%" }}
                        placeholder={i18n.t("form.enter_attributes")}
                        notFoundContent={<span>{i18n.t("table_no_types")}</span>}
                        disabled={props.isFieldDisabled}
                      >
                        {!!attributes &&
                          attributes.map((attribute) => !!attribute && <Option key={attribute}>{attribute}</Option>)}
                      </Select>
                    </Form.Item>
                  )}
                </Card>
              </Collapse.Panel>
            );
          })}
        </Collapse>
      </Col>
    </Row>
  );
};

export default TranslationField;
